export enum AuthActivateStepStatus {
  WAIT,
  PROGRESS,
  SUCCESS,
  ERROR,
}
